<template>
  <div v-if="schema && isCatalogReady">
    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <div class="row bg-light-gray border-radius--light  pb-3 pt-1">
        <div class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.service.rules"
            :custom-messages="schema.service.validationMessages"
          >
            <label class="input-label" v-text="schema.service.label" />
            <CustomDropDown
              v-model="model.service"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.services"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="editting"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <template v-if="isVisible('other')">
          <div class="col-12 col-sm-6 col-md-4 pt-2">
            <ValidationProvider
              v-slot="{ validate, errors }"
              mode="lazy"
              :rules="schema.other.rules"
              :custom-messages="schema.other.validationMessages"
            >
              <label class="input-label" v-text="schema.other.label" />
              <CustomInput
                v-model="model.other"
                :error="errors[0]"
                :custom-error-msg="errors[0]"
                @input="validate"
              />
            </ValidationProvider>
          </div>
        </template>
        <div v-if="isVisible('modality')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.modality.rules"
            :custom-messages="schema.modality.validationMessages"
          >
            <label class="input-label" v-text="schema.modality.label" />
            <CustomDropDown
              v-model="model.modality"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.modalities"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.modalities && catalog.modalities.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('approach')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.approach.rules"
            :custom-messages="schema.approach.validationMessages"
          >
            <label class="input-label" v-text="schema.approach.label" />
            <CustomDropDown
              v-model="model.approach"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.approaches"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.approaches && catalog.approaches.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div
          v-if="isVisible('frequency')"
          class="col-12 col-sm-6 col-md-4 pt-2"
        >
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.frequency.rules"
            :custom-messages="schema.frequency.validationMessages"
          >
            <label class="input-label" v-text="schema.frequency.label" />
            <CustomDropDown
              v-model="model.frequency"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.frequencies"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.frequencies && catalog.frequencies.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('duration')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.duration.rules"
            :custom-messages="schema.duration.validationMessages"
          >
            <label class="input-label" v-text="schema.duration.label" />
            <CustomDropDown
              v-model="model.duration"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.durations"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.durations && catalog.durations.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('dutyTime')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.dutyTime.rules"
            :custom-messages="schema.dutyTime.validationMessages"
          >
            <label class="input-label" v-text="schema.dutyTime.label" />
            <CustomInput
              v-model.number="model.dutyTime"
              type="number"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('teacher')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.teacher.rules"
            :custom-messages="schema.teacher.validationMessages"
          >
            <label class="input-label" v-text="schema.teacher.label" />
            <CustomDropDown
              v-model="model.teacher"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.teachers"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.teachers && catalog.teachers.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div
          v-if="isVisible('equipment')"
          class="col-12 col-sm-6 col-md-4 pt-2"
        >
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.equipment.rules"
            :custom-messages="schema.equipment.validationMessages"
          >
            <label class="input-label" v-text="schema.equipment.label" />
            <CustomInput
              v-model="model.equipment"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('place')" class="col-12 col-sm-6 col-md-4 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.place.rules"
            :custom-messages="schema.place.validationMessages"
          >
            <label class="input-label" v-text="schema.place.label" />
            <CustomDropDown
              v-model="model.place"
              placeholder="Seleccione"
              fieldkey="id"
              fieldname="name"
              :options="catalog.places"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              :disabled="!(catalog.places && catalog.places.length)"
              @input="validate"
            />
          </ValidationProvider>
        </div>
        <div v-if="isVisible('comment')" class="col-12 pt-2">
          <ValidationProvider
            v-slot="{ validate, errors }"
            mode="lazy"
            :rules="schema.comment.rules"
            :custom-messages="schema.comment.validationMessages"
          >
            <label class="input-label" v-text="schema.comment.label" />
            <CustomTextArea
              v-model="model.comment"
              :placeholder="'Agrega un comentario'"
              :maxlength="200"
              :rows="3"
              :disabled="editting"
              :error="errors[0]"
              :custom-error-msg="errors[0]"
              @input="validate"
            />
          </ValidationProvider>
        </div>

        <div
          class="buttons-container d-flex justify-content-end  col-md-2 offset-md-10"
        >
          <ActionButton
            variant="outline-danger m-1"
            i="fas fa-times-circle"
            :responsive="true"
            @click="cancel"
          >
            Cancelar
          </ActionButton>
          <ActionButton
            variant="success m-1"
            :i="`fas fa-${editting ? 'save' : 'file-plus'}`"
            :responsive="true"
            @click="handleSubmit(submit)"
          >
            {{ editting ? 'Guardar' : 'Añadir' }}
          </ActionButton>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  CustomDropDown,
  CustomInput,
  CustomTextArea,
} from '@/components/common';
import { modelInitialState } from '../_utils';
import ActionButton from 'ActionButton';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';
import moment from 'moment';

export default {
  name: 'ServiceForm',
  components: {
    CustomDropDown,
    CustomInput,
    CustomTextArea,
    ActionButton,
  },
  props: {
    schema: { type: Object, required: true, default: null },
    item: { type: Object, default: null },
    editting: { type: Boolean, default: false },
    statusId: { type: Number, default: 0 },
  },
  data: () => ({ model: modelInitialState() }),
  computed: {
    isCatalogReady() {
      // Verificar que catalog existe (puede venir del mixin o no estar definido)
      if (!this.catalog) {
        return false;
      }

      // Verificar que tiene las propiedades básicas necesarias
      return (
        Array.isArray(this.catalog.services) &&
        Array.isArray(this.catalog.modalities) &&
        Array.isArray(this.catalog.frequencies) &&
        Array.isArray(this.catalog.durations)
      );
    },
  },
  methods: {
    isVisible(key) {
      if (!this.schema[key]) {
        return false;
      }

      // Para el campo comment, verificar si el estatus es "Proceso de Enmienda"
      if (key === 'comment') {
        const isProcessAmendment =
          this.statusId === tapRequestStatusesEnum['Proceso de Enmienda'];

        // Si está editando, solo mostrar si el servicio tiene comentario
        if (this.editting) {
          return (
            isProcessAmendment &&
            this.model.comment &&
            this.model.comment.trim() !== ''
          );
        }

        // Si no está editando, mostrar si es proceso de enmienda y es servicio nuevo
        return isProcessAmendment && Number(this.model.id) === 0;
      }

      const visibleIf = this.schema[key]?.visibleIf;
      if (!visibleIf) {
        return true;
      }

      const valueToCompare = visibleIf.valueKey
        ? this.model[visibleIf.property]?.[visibleIf.valueKey]
        : this.model[visibleIf.property];
      if (valueToCompare) {
        return [...visibleIf.includes].includes(valueToCompare);
      }

      return false;
    },
    submit() {
      const dto = { ...this.model };

      // Si hay comentario y es un servicio nuevo, añadir fecha, username y rol
      if (
        dto.comment &&
        !this.editting &&
        Number(this.model.id) === 0 &&
        this.statusId === tapRequestStatusesEnum['Proceso de Enmienda']
      ) {
        const now = moment();
        let formattedDate = now
          .locale('es-PR')
          .format('DD/MMM/YYYY h:mm a')
          .toLowerCase();
        // Añadir punto después del mes (ej: nov. en lugar de nov)
        formattedDate = formattedDate.replace(/\/([a-z]{3})\//, '/$1./');
        dto.commentDate = formattedDate;

        // Obtener información del usuario de la sesión
        const userProfile = this.$store.getters['$_user/fullProfile'];
        if (userProfile) {
          dto.commentCreatedBy = userProfile.givenname || null;
          dto.commentedByUsername = userProfile.name || null;
          dto.commentedByRoleName = userProfile.role || null;
        } else {
          dto.commentedByUsername = null;
          dto.commentedByRoleName = null;
          dto.commentCreatedBy = null;
        }
      }

      this.$emit('submit', dto, this.cancel);
    },
    cancel() {
      this.model = modelInitialState();
      this.$refs['form'].reset();
      this.$emit('cancel');
    },
  },
  created() {
    if (this.item) {
      this.model = { ...this.model, ...this.item };
    }
  },
};
</script>

<style>
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}
</style>
